import { TreePine, Phone, Mail, MapPin } from "lucide-react";
import { useSettings, getPhoneLines } from "@/lib/settings";

export default function Footer() {
  const settings = useSettings();
  return (
    <footer className="bg-[#1A1D1A] text-[#FBF9F5] mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 rounded-lg bg-[#D97706] text-white flex items-center justify-center">
              <TreePine className="w-5 h-5" />
            </span>
            <span className="font-display font-extrabold text-xl">Hobby<span className="text-[#D97706]">Center</span></span>
          </div>
          <p className="text-sm text-stone-400 leading-relaxed">
            Lesni iverali, razrez in robljenje po meri, kuhinjski elementi, delovne plošče in pohištveno okovje — vse za vaš projekt na enem mestu.
          </p>
        </div>
        <div>
          <h4 className="font-display font-bold mb-4 text-sm uppercase tracking-wider text-[#D97706]">Ponudba</h4>
          <ul className="space-y-2 text-sm text-stone-300">
            <li><a href="/trgovina?category=iverali" data-testid="footer-link-iverali" className="hover:text-white transition-colors">Lesni iverali in plošče</a></li>
            <li><a href="/trgovina?category=delovne-plosce" data-testid="footer-link-delovne" className="hover:text-white transition-colors">Delovne plošče</a></li>
            <li><a href="/trgovina?category=kuhinjski-elementi" data-testid="footer-link-kuhinje" className="hover:text-white transition-colors">Kuhinjski elementi</a></li>
            <li><a href="/trgovina?category=pohistveno-okovje" data-testid="footer-link-okovje" className="hover:text-white transition-colors">Pohištveno okovje</a></li>
            <li><a href="/#razrez" data-testid="footer-link-razrez" className="hover:text-white transition-colors">Razrez in robljenje</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold mb-4 text-sm uppercase tracking-wider text-[#D97706]">Podjetje</h4>
          <ul className="space-y-2 text-sm text-stone-300">
            <li><a href="/#o-nas" className="hover:text-white transition-colors">O nas</a></li>
            <li><a href="/#kontakt" className="hover:text-white transition-colors">Kontakt</a></li>
            <li><a href="/trgovina?akcija=1" className="hover:text-white transition-colors">Akcijska ponudba</a></li>
            <li><a href="/admin" data-testid="footer-link-admin" className="hover:text-white transition-colors">Admin prijava</a></li>
            <li><a href="/pogoji-poslovanja" data-testid="footer-link-pogoji" className="hover:text-white transition-colors">Pogoji poslovanja</a></li>
            <li><a href="/piskotki" data-testid="footer-link-piskotki" className="hover:text-white transition-colors">Pravilnik o piškotkih</a></li>
            <li><a href="/pravna-obvestila" data-testid="footer-link-pravna" className="hover:text-white transition-colors">Pravna obvestila</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold mb-4 text-sm uppercase tracking-wider text-[#D97706]">Kontakt</h4>
          <ul className="space-y-3 text-sm text-stone-300">
            {getPhoneLines(settings).map((l, i) => (
              <li key={i} className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-[#D97706] shrink-0" />
                {l.oddelek && <span className="text-stone-500">{l.oddelek}:</span>} {l.stevilka}
              </li>
            ))}
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#D97706]" /> {settings.email}</li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-[#D97706] mt-0.5" /> {settings.naslov},<br />{settings.posta_kraj}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#323832]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-stone-500 font-tech">
          <span>© 2026 HobbyCenter. Vse pravice pridržane.</span>
          <span>Cene vključujejo 22 % DDV.</span>
        </div>
      </div>
    </footer>
  );
}
